import { type JSX } from "react";

import { trackEvent, useFlags } from "utils";

type FeatureProps = {
  flag: string;
  flagValue?: unknown;
  fallback: () => JSX.Element;
  children: JSX.Element;
};

/**
 * Feature component lets you declare a fallback if a flag is false. If true
 * children of the component will be rendered.
 *
 * ```
 * <Feature flag="newThing" fallback={() => <Navigate to="/" />}>
 *   <div>Only rendered when flag is on!</div>
 * </Feature>
 * ```
 */
export const Feature = ({
  flag,
  fallback,
  children,
  flagValue = true,
}: FeatureProps) => {
  const flags = useFlags();
  if (flags[flag] === flagValue) {
    return children;
  }
  trackEvent("Feature component returning fallback", { flag });
  return fallback();
};
